import "./Contact.css";
import EmailForm from "./EmailForm";
import useTranslation from "../../../../hooks/i18n/useTranslation";

export const Contact = () => {
  const { t } = useTranslation();
  return (
    <div className="support-content-inner contact-container">
      <div className="support-section-header">
        <h1 className="support-section-title">{t("342")}</h1>
        <p className="support-section-description">
          {t("343")}
        </p>
      </div>
      <div className="contact-inner-wrapper">
        <div className="contact-content">
          <EmailForm />
        </div>
      </div>
    </div>
  );
};
